/** Display helpers for recipient chip menus (Outlook-style). */

export function chipInitial(chip: string): string {
  return (chip.split("@")[0] || chip).slice(0, 1).toUpperCase();
}

export function chipDisplayName(chip: string): string {
  const angle = chip.match(/^(.+?)\s*<([^>]+@[^>]+)>$/);
  if (angle?.[1]?.trim()) return angle[1].trim();
  const local = chip.split("@")[0]?.trim();
  if (!local) return chip;
  return local
    .replace(/[._+-]+/g, " ")
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

export function chipEmail(chip: string): string {
  const angle = chip.match(/<([^>]+@[^>]+)>/);
  if (angle) return angle[1]!.trim();
  return chip.trim();
}
